import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import helpCenterService from "../services/help-center-service";

export const helpTopicSearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
	help_category_id: z.string().nullable().optional(),
	slug: z.string().nullable().optional(),
});

export const helpCenterQueryOptions = (search?: z.infer<typeof helpTopicSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["help_center", search],
		queryFn: () => helpCenterService.list(transformSearch(search, ["search", "help_category_id", "slug"])),
		...options,
	});
};
